import React, { ChangeEventHandler } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { FormikTouched } from 'formik/dist/types';
import { useAuthContext } from '../../../../contexts/authContext';

type Props = {
    data?: any[];
    label: string;
    name: string;
    size?: 'small' | 'medium' | undefined;
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: string | undefined;
    defineValue?: string | undefined;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: any;
    disabled?: boolean;
    onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

const FieldSelect = ({
    data,
    label,
    name,
    size,
    margin,
    required,
    touched,
    errors,
    value,
    defineValue,
    disabled,
    onChange,
}: Props) => {
    //onChange Formik
    //The variable filedSelectFormik must be equal to the variable name of the formik
    //onChange={formik.handleChange}

    const { modeTheme } = useAuthContext();

    return (
        <>
            <TextField
                id="select-field"
                select
                fullWidth
                label={label}
                name={name}
                value={value}
                required={required}
                margin={margin}
                disabled={disabled}
                onChange={onChange}
                size={size}
                helperText={touched ? errors : ''}
                error={touched && Boolean(errors)}
                sx={{
                    '& label.Mui-focused': {
                        color:
                            modeTheme === 'darkMode'
                                ? 'primary.contrastText'
                                : 'primary.main',
                    },
                    '& .MuiInput-underline:after': {
                        borderBottomColor:
                            modeTheme === 'darkMode'
                                ? 'primary.contrastText'
                                : 'primary.main',
                    },
                    '& .MuiFilledInput-underline:after': {
                        borderBottomColor:
                            modeTheme === 'darkMode'
                                ? 'primary.contrastText'
                                : 'primary.main',
                    },
                    '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                            borderColor:
                                modeTheme === 'darkMode'
                                    ? 'primary.contrastText'
                                    : 'primary.main',
                        },
                    },
                }}
            >
                {/*<MenuItem key="" value="">VACIO</MenuItem>*/}
                {data &&
                    data?.map((option: any) => (
                        <MenuItem
                            key={option.id}
                            value={
                                defineValue === 'value'
                                    ? option.name
                                    : option.id
                            }
                        >
                            {option.name}
                        </MenuItem>
                    ))}
            </TextField>
        </>
    );
};

export default FieldSelect;
